import React from "react";
import useCopyToClipboard from "../hooks/useCopyToClipboard";
import Copy from "./SVGIcons/Copy";
import Tooltip from "./Tooltip";

interface Props {
  message: string;
}

export const UserChatMessage = React.forwardRef<HTMLDivElement, Props>(
  ({ message }, ref) => {
    const [isCopied, copy] = useCopyToClipboard();

    return (
      <div ref={ref} className="group flex items-center justify-end gap-4">
        <Tooltip text={`${isCopied ? "Copied!" : "Copy"}`} position="bottom">
          <div
            className="hidden cursor-pointer rounded-full px-3.5 pb-2 pt-3 hover:bg-grayscale-solid-g2 group-hover:block"
            onClick={() => copy(message)}
          >
            <Copy className="h-4 w-4 fill-grayscale-solid-g10" />
          </div>
        </Tooltip>
        <div className="flex max-w-[500px] flex-col items-center justify-start gap-4 rounded-[4px] rounded-bl-[20px] rounded-tl-[20px] rounded-tr-[20px] bg-grayscale-solid-elevate-level2 px-6 py-4 text-xs font-normal leading-[18px] text-grayscale-solid-g10 shadow sm:text-sm">
          {message}
        </div>
      </div>
    );
  },
);
